
import {map} from 'rxjs/operators';
import { QueueCategory } from './../ticket/qaticket-config.component';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorage } from '../shared/localstorage.service';
import { reject } from 'q';
import { Question, QAResponse, QATicket, ViewTicketResponse, SendFeedBack, SendFeedBackToEmailAndType, RolesForSendingFeedback, QATicketNotes, QATicketActivity, QATicketDisputeDetails } from './qaTicket';
import { TicketCode, TicketNotes, TicketHistory } from './ticket';

@Injectable()
export class QuestionService {
    constructor(private http: HttpClient, private _router: Router, private localStorage: LocalStorage) { }
    ticketQuestions: Question[];
    updatedQuestions: Question[];
    getActive(state: string) {
        return new Promise<Question[]>(resolve => {
            this.http.get<Question[]>('/api/question/', { params: { state: state}})
                .subscribe(data => {
                    this.ticketQuestions = data;
                    resolve(this.ticketQuestions);
                });
            setTimeout(() => resolve(new Array<Question>()), 100000);
        });
    }

    addQuestion(newQuestion: Question, state: string): Promise<Question[]> {
        
        return new Promise<Question[]>(resolve => {
            this.http.post(`api/question/NewQuestion?state=${state}`, {
                CanNA: newQuestion.CanNA, Condition: newQuestion.Condition,
                Section: newQuestion.Section, QuestionText: newQuestion.QuestionText, Order: newQuestion.Order,
                CriticalLevel: newQuestion.CriticalLevel, CustomResponse: newQuestion.CustomResponse,
                QueueCategory: newQuestion.QueueCategory, ValidResponse: newQuestion.ValidResponse
            }).pipe(
                map(res => res as Question[] || []))
                .subscribe(data => {
                    this.updatedQuestions = data;
                    resolve(this.updatedQuestions);
                });
            // Error handling
            setTimeout(() => resolve(new Array<Question>()), 100000);
        });
    }

    updateQuestionOrder(order: Array<Number>, state: string) {
        return new Promise<Question[]>(resolve => {
            this.http.post(`/api/question/SaveQuestionOrder?state=${state}`, { QuestionIds: order }).pipe(
                map(data => data as Question[] || []))
                .subscribe(data => {
                    this.updatedQuestions = data;
                    resolve(this.updatedQuestions);
                });
            setTimeout(() => resolve(), 100000);
        });
    }

    removeQuestion(QuestionId: Number, state: string) {
        return new Promise<Question[]>(resolve => {
            this.http.post(`/api/question/RemoveQuestion?state=${state}`, QuestionId).pipe(
                map(data => data as Question[] || []))
                .subscribe(data => {
                    this.updatedQuestions = data;
                    resolve(this.updatedQuestions);
                });
            setTimeout(() => resolve(), 100000);
        });
    }

    saveQATicket(GCNumber: string, Feedback: Array<string>, UserName: string,
        QAStart: string, Responses: QAResponse[], TicketCorrection: string, QAGeom: string, QAGeomCodes: TicketCode[],
        GCTakenBy: string, QueueCategory: string, QATicketNotes: QATicketNotes, PacketId: number, GCTicketID: string, state: string, token: string) {
            
        return new Promise(resolve => {
            this.http.post(`api/ticket?state=${state}&token=${token}`,
                {
                    GCNumber: GCNumber, Feedback: Feedback, QualityUser: UserName,
                    QualityStart: QAStart, Response: Responses, TicketCorrection: TicketCorrection, QAGeom: QAGeom,
                    QAGeomCodes: QAGeomCodes,
                    GCTakenBy: GCTakenBy, QueueCategory: QueueCategory, QATicketNotes: QATicketNotes, PacketId: PacketId, GCTicketID: GCTicketID
                })
                .subscribe(data => {
                    resolve(data);
                });
            setTimeout(() => resolve('An error occured.'), 100000);
        });
    }

    getQATicket(gcNumber: string, state: string): Promise<ViewTicketResponse> {
        return new Promise<ViewTicketResponse>(resolve => {
            this.http.get<ViewTicketResponse>('api/question/getqaticket', { params: { gcNumber, state } })
                .subscribe(data => {
                    resolve(data);
                });
            setTimeout(() => resolve(new ViewTicketResponse()), 100000);
        });

    }
    getQATicketByQATicketId(QATicketId: number, state: string): Promise<ViewTicketResponse> {
        return new Promise<ViewTicketResponse>(resolve => {
            this.http.get<ViewTicketResponse>(`api/question/GetQATicketByQATicketId?QATicketId=${QATicketId}&state=${state}`)
                .subscribe(data => {
                    resolve(data);
                });
            setTimeout(() => resolve(new ViewTicketResponse()), 100000);
        });

    }
    getRolesForUserToSendFeedBack(gcToken: string, UserName: string, state: string): Observable<RolesForSendingFeedback> {
        return this.http.get<RolesForSendingFeedback>(`api/notification/GetRolesForUser?gcToken=${gcToken}&UserName=${UserName}&state=${state}`);
    }

    getEmailAddressForUserToSendFeedBack(gcToken: string, UserName: string, state: string) {
        return this.http.get(`api/notification/GetEmailForUser?gcToken=${gcToken}&UserName=${UserName}&state=${state}`);
    }
    getTicketNotes(gcToken: string, gcTicketId: string, state: string): Observable<TicketNotes> {
        return this.http.get<TicketNotes>(`api/ticket/getticketnotes?gcToken=${gcToken}&gcTicketId=${gcTicketId}&state=${state}`);
    }

    getTicketHistory(gcToken: string, gcTicketId: string, gcTicketNumber: string, gcTakenBy: string, ticketType:
        string, gcCreation: string, state: string): Observable<TicketHistory[]> {
        return this.http.get<TicketHistory[]>(`api/ticket/gettickethistory?gcToken=${gcToken}&gcTicketId=${gcTicketId}&gcTicketNumber=${gcTicketNumber}&gcTakenBy=${gcTakenBy}&ticketType=${ticketType}&gcCreation=${gcCreation}&state=${state}`);
    }

    getQualityNotes(qaTicketId: number, state: string): Observable<QATicketNotes[]> {
        return this.http.get<QATicketNotes[]>(`api/QualityNotes/viewnotes?qaTicketId=${qaTicketId}&state=${state}`);
    }

    addQualityNotes(QATicketId: number, UserName: string, Subject: string, Message: string, state: string): Observable<QATicketNotes[]> {
        return this.http.post<QATicketNotes[]>(`api/QualityNotes/addnotes?state=${state}`, {
            QATicketId: QATicketId,
            UserName: UserName, Subject: Subject, Message: Message
        });
    }

    addQualityNotesAndUpdateActivity(QATicketId: number, UserName: string, Subject: string, Message: string, Activity: string, state: string): Observable<QATicketNotes[]> {
        return this.http.post<QATicketNotes[]>(`api/QualityNotes/addnotesandupdateactivity?state=${state}`, {
            QATicketId: QATicketId,
            UserName: UserName, Subject: Subject, Message: Message, Activity: Activity
        });

    }

    addQualityNotesAndAddDisputeActivity(QATicketId: number, UserName: string, Subject: string, Message: string, Activity: string, QuestionId: number, state: string, token: string): Observable<QATicketNotes[]> {
        return this.http.post<QATicketNotes[]>(`api/QualityNotes/addnotesandadddisputeactivity?state=${state}&token=${token}`, {
            QATicketId: QATicketId,
            UserName: UserName, Subject: Subject, Message: Message, Activity: Activity, QuestionId: QuestionId
        });
    }

    getDisputeDetails(qaTicketId: number, state: string){
        return this.http.get<QATicketActivity[]>(`api/QualityNotes/getdisputetickets?qaTicketId=${qaTicketId}&state=${state}`);
    }

    getDisputeDetailsWithQuestionInfo(ID: number, state: string): Observable<QATicketDisputeDetails[]>{
        return this.http.get<QATicketDisputeDetails[]>(`api/QualityNotes/getdisputeticketdetails?ID=${ID}&state=${state}`);
    }

    addDisputeNotes(QATicketId: number, UserName: string, Subject: string, Message: string, Activity: string, QuestionId: number, QATicketActivityId: number, state: string, token: string): Observable<QATicketDisputeDetails[]> {
        return this.http.post<QATicketDisputeDetails[]>(`api/QualityNotes/addnotesdispute?state=${state}&token=${token}`, {
            QATicketId: QATicketId,
            UserName: UserName, Subject: Subject, Message: Message, Activity: Activity, QuestionId: QuestionId,
            QATicketActivityId: QATicketActivityId
        });
    }

    addQualityNotesAndUpdateDisputeActivity(QATicketId: number, UserName: string, Subject: string, Message: string, Activity: string,  QuestionId: number, QATicketActivityId: number, state: string, token: string): Observable<QATicketDisputeDetails[]> {
        return this.http.post<QATicketDisputeDetails[]>(`api/QualityNotes/addnotesandupdatedisputeactivity?state=${state}&token=${token}`, {
            QATicketId: QATicketId,
            UserName: UserName, Subject: Subject, Message: Message, Activity: Activity, QuestionId: QuestionId,
            QATicketActivityId: QATicketActivityId
        });

    }
}
